import { ArticleModel } from "@/Generated/ParticaAPI";
import { Article } from "@/Models/ArticleModels/article";

export class ArticleUtils {

	public convertarticle<T>(article: ArticleModel): T {
		const tmp: Article = new Article();
		tmp.set(article);
		return tmp as unknown as T;
	}

	public convertarticlearray<T>(articles: ArticleModel[]): T[] {
		const tmparray: Article[] = [];
		articles.forEach(a => {
			const tmp: Article = new Article();
			tmp.set(a);
			tmparray.push(tmp);
		});
		return tmparray as unknown as T[];
	}
	/*
		public copy<T>(obj: T): T {
			return JSON.parse(JSON.stringify(obj)) as T;
		}
	*/
}

// tslint:disable-next-line: max-classes-per-file
export class Guid {
	public static newGuid(): string {
		/* tslint:disable */
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
			const r: any = Math.random() * 16 | 0, v = c == "x" ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
}
